"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Orbus Artwork Uploader
 * Artwork uploader, PDF preflight queue & processor.  Please refer to the [AWS Developer Guide](https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingRESTAPImpUpload.html) for multipart uploads.  The upload-related methods do not take file data themselves, rather they act as helper methods for using the AWS S3 APIs.  It is strongly recommended that you use Uppy and its [AWS S3 Multipart plugin](https://uppy.io/docs/aws-s3-multipart/) to assist with uploading files. The provided demo/example code offers a functioning example.
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListPartsResponsePartToJSON = exports.ListPartsResponsePartFromJSONTyped = exports.ListPartsResponsePartFromJSON = void 0;
function ListPartsResponsePartFromJSON(json) {
    return ListPartsResponsePartFromJSONTyped(json, false);
}
exports.ListPartsResponsePartFromJSON = ListPartsResponsePartFromJSON;
function ListPartsResponsePartFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'PartNumber': json['PartNumber'],
        'Size': json['Size'],
        'ETag': json['ETag'],
    };
}
exports.ListPartsResponsePartFromJSONTyped = ListPartsResponsePartFromJSONTyped;
function ListPartsResponsePartToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'PartNumber': value.PartNumber,
        'Size': value.Size,
        'ETag': value.ETag,
    };
}
exports.ListPartsResponsePartToJSON = ListPartsResponsePartToJSON;
